import { createContext, useReducer, useMemo } from "react";
import { withRouter } from "react-router-dom";

import rewardReducer from "src/containers/reward/reward.reducer";

export const RewardContext = createContext({
    viewType: '',
    current: 1,
    pageSize: 12,
    setCriteria: () => { }
});

const { reducer, defaultValue, TYPES } = rewardReducer;

export const RewardProvider = withRouter(({ children }) => {
    const [state, dispatch] = useReducer(reducer, defaultValue);

    const RewardContextValue = useMemo(() => {
        return {
            ...state,
            setCriteria: (payload) => {
                dispatch({
                    type: TYPES.SET_CRITERIA,
                    payload
                });
            }
        };
    }, [state, dispatch]);

    return (
        <RewardContext.Provider value={RewardContextValue}>
            {children}
        </RewardContext.Provider>
    );
});

export default RewardContext;